/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { PublicClouds } from './components';

export const BackupJobsPublicCloudsPage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <PublicClouds />
    </TabBarBodyLayout>
);
